module.exports = __webpack_public_path__ + "media/images/4-off-cd1478c810518902293bc9c1ce5a5f3b.png";